module.exports = __webpack_public_path__ + "static/media/trubi.270c287a.svg";